import React, { lazy } from 'react';
import { Switch, Route, Redirect, useRouteMatch, useLocation } from 'react-router-dom';
import BuildHome from 'packages/app-builds/routes/HomeWrapper';
import { isAdmin } from '@appmaker/core/store/user';

const BuildConfig = lazy(() => import('packages/admin-tools/routes/AppBuildConfig'));
const Extensions = lazy(() => import('packages/extensions/routes/Extensions'));
const ExtensionList = lazy(() => import('packages/extensions/routes/ExtensionList'));
const ExtensionInstall = lazy(() => import('packages/extensions/routes/ExtensionInstall'));
const ExtensionDetails = lazy(() => import('packages/extensions/routes/ExtensionDetails'));
const ExtensionDetailsRoute = lazy(() => import('packages/extensions/routes/ExtensionDetailsRoute'));
const Themes = lazy(() => import('packages/themes/routes/Home'));
const ThemePreview = lazy(() => import('packages/themes/routes/ThemePreview'));
const ThemeDetailRoute = lazy(() => import('packages/themes/routes/ThemeDetailRoute'));

export default function ProjectBuildRoutes({ renderBuild = (Component) => <Component /> }) {
    const { path, url } = useRouteMatch();
    const { search } = useLocation();
    const buildLocation = { pathname: `${url}/app-builds`, search };
    return (
        <Switch>
            <Route exact path={`${path}/app-builds`}>
                {renderBuild(BuildHome)}
            </Route>
            <Route exact path={`${path}/app-builds/config`}>
                {isAdmin() ? renderBuild(BuildConfig) : <Redirect to={buildLocation} />}
            </Route>
            <Route exact path={`${path}/extension`}>
                {renderBuild(Extensions)}
            </Route>
            <Route exact path={`${path}/extension-list`}>
                {renderBuild(ExtensionList)}
            </Route>
            <Route exact path={`${path}/extension/install/:handle`}>
                {renderBuild(ExtensionInstall)}
            </Route>
            <Route exact path={`${path}/extension/:handle/:route(version|backend-settings)`}>
                {renderBuild(ExtensionDetailsRoute)}
            </Route>
            <Route exact path={`${path}/extension/:handle`}>
                {renderBuild(ExtensionDetails)}
            </Route>
            <Route exact path={`${path}/themes`}>
                {renderBuild(Themes)}
            </Route>
            <Route exact path={`${path}/themes/:handle/:route(version)`}>
                {renderBuild(ThemeDetailRoute)}
            </Route>
            <Route exact path={`${path}/themes/:handle`}>
                {renderBuild(ThemePreview)}
            </Route>
            <Redirect to={buildLocation} />
        </Switch>
    );
}
